import * as React from 'react';
import { SVGProps } from 'react';

const IconExitSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 14H1V2h10v2H3v8h8v2Z" />
    <path d="m15 8-3 3V9H5V7h7V5l3 3Z" />
  </svg>
);
export default IconExitSizeS;
